import { useEffect, useRef, useState } from 'react';

const MINIMUM_VISIBLE_DURATION_MS = 800;

export const useLoadingState = (isLoading: boolean) => {
  const [isMinimumDurationPending, setIsMinimumDurationPending] = useState(isLoading);
  const minimumDurationTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!isLoading) {
      return;
    }

    clearTimeout(minimumDurationTimeoutRef.current);
    setIsMinimumDurationPending(true);
    minimumDurationTimeoutRef.current = setTimeout(
      () => setIsMinimumDurationPending(false),
      MINIMUM_VISIBLE_DURATION_MS,
    );
  }, [isLoading]);

  useEffect(() => () => clearTimeout(minimumDurationTimeoutRef.current), []);

  return isLoading || isMinimumDurationPending;
};
